import { FC } from 'react';

import { usePage } from '@inertiajs/react';

import { ProductCardsGrid } from './ProductCardsGrid';
import { CartonProduct } from '../../types';

type PageProps = {
    productName: string;
    products: CartonProduct[];
};

const Versions: FC = () => {
    const { productName, products } = usePage<PageProps>().props;

    return (
        <main className="flex-1">
            <section className="bg-muted/30 py-4">
                <div className="container">
                    <h1
                        className="text-xl font-bold md:text-2xl"
                        data-testid="product-versions-heading"
                    >
                        {productName}
                    </h1>
                </div>
            </section>

            <section className="py-6 sm:py-8">
                <div className="container px-4 sm:px-6 lg:px-8">
                    <ProductCardsGrid
                        products={products}
                        testId="product-versions-grid"
                    />
                </div>
            </section>
        </main>
    );
};

export default Versions;
